// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3G_f6","title":"Header_title__2ErwO","side":"Header_side__SxbZd"};